<template>
    <div @click="showNoticeAll(); $Util.sendEventClick('사커하우_알림')" style="position: relative;">
        <div v-if="noticeCount > 0" style="width: 10px; position: absolute; right: -2px; top: -2px; height: 10px; font-size: 8px; border-radius: 50%; background-color: red; color: #fff; display: flex; justify-content: center; align-items: center;"></div>
        <img style="width: 20px; height: 21px;" :src="require('@/assets/img/alarm_gray.png')">
    </div>
</template>

<script>
export default {
    name: 'AlarmIcon',
    methods: {
        async showNoticeAll() {
            if (!this.$Util.checkLoginAndWeb()) {
                return
            }
            // await this.getNoticeCount();
            this.$GlobalStore.addModal('NoticeAll');
        },
        // async getNoticeCount() {
        //     const res = await this.$Axios.get('/api/my/notice/count');
        //     this.noticeCount = res.data.noticeCount;
        // },
    },
    computed: {
        noticeCount() {
            return this.$GlobalStore.noticeCount()
        }
    }
}
</script>

<style scoped></style>